// Desktop enhancement; native disclosure controls remain available for touch and keyboard.
(() => {
  // Sortuje po polsku WYŁĄCZNIE pozycje wewnątrz kolumn megamenu.
  // Nie zmienia nagłówków kolumn, ich kolejności ani wspólnej nawigacji Shopify.
  const mcPolishMenuOrder = new Intl.Collator('pl-PL', {
    sensitivity: 'base',
    numeric: true
  });

  const sortMenuColumns = () => {
    document
      .querySelectorAll('.header__inline-menu .mega-menu__list ul.list-unstyled')
      .forEach((columnList) => {
        const entries = Array.from(columnList.children)
          .filter((element) => element.tagName === 'LI');
        if (entries.length < 2) return;

        const label = (item) => (
          item.querySelector(':scope > a, :scope > h3')?.textContent || ''
        ).trim();

        const sorted = [...entries].sort((a, b) =>
          mcPolishMenuOrder.compare(label(a), label(b))
        );
        if (entries.some((item, index) => item !== sorted[index])) {
          sorted.forEach((item) => columnList.appendChild(item));
        }
      });
  };

  const initialize = () => {
    sortMenuColumns();
    document.querySelectorAll('.header__inline-menu header-menu').forEach((menu) => {
      if (menu.dataset.mcHoverReady) return;
      menu.dataset.mcHoverReady = 'true';
      const details = menu.querySelector('details');
      const summary = details?.querySelector('summary');
      if (!summary) return;
      const desktopMouse = (event) => event.pointerType === 'mouse' && window.matchMedia('(min-width: 990px) and (hover: hover)').matches;
      let closeTimer;
      const close = () => {
        clearTimeout(closeTimer);
        if (typeof menu.close === 'function') menu.close();
        else details.open = false;
        summary.setAttribute('aria-expanded', 'false');
      };
      menu.addEventListener('pointerenter', (event) => {
        if (!desktopMouse(event)) return;
        clearTimeout(closeTimer);
        document.querySelectorAll('.header__inline-menu header-menu').forEach((other) => {
          if (other !== menu && typeof other.close === 'function') other.close();
        });
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      });
      menu.addEventListener('pointerleave', (event) => {
        if (!desktopMouse(event)) return;
        closeTimer = setTimeout(() => {
          if (!menu.contains(document.activeElement) || document.activeElement === summary) close();
        }, 180);
      });
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          close();
          summary.focus();
        }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();